module.exports = __webpack_public_path__ + "img/sass.8e766e95.svg";